export const themeOverrides = {
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        body {
          background: #222222;
        }
        #root {
          display: flex;
          flex-direction: column;
          flex-wrap: nowrap;
          height: 100%;
          min-height: 100%;
          overflow: hidden;
          user-select: none;
          width: 100%;
        }
        .live-lobby-content::-webkit-scrollbar {
          width: 12px;
        }
        .live-lobby-content::-webkit-scrollbar-track {
            background: #000000;
            border-radius: 4px;
            border: none;
        }
        .live-lobby-content::-webkit-scrollbar-thumb {
            background: #aaaaaa;
            border-radius: 4px;
        }
      `,
    },
  },
  typography: {
    muted: {
      opacity: '.6',
    },
  },
  palette: {
    mode: 'dark',
    primary: {
      main: '#3970a9',
    },
    secondary: {
      main: '#818181',
    },
    toolbar: {
      main: '#ffffff',
    }
  },
}
